import React, { Component } from 'react';
import ComTable from '../ComTable';

class Language extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '语种',
            en: 'Language',
            key: 'language',
        }, {
            zh: '说',
            en: 'Speaking',
            key: 'speak',
            width: 200,
        }, {
            zh: '读',
            en: 'Reading',
            key: 'read',
            width: 200,
        }, {
            zh: '写',
            en: 'Writing',
            key: 'write',
            width: 200,
        }];
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                languageName,
                languageNameEnglish,
                speakingName,
                speakingNameEnglish,
                readingName,
                readingNameEnglish,
                writingName,
                writingNameEnglish,
            } = item;
            return {
                index: index + 1,
                ...item,
                language: `${isChinese ? languageName : languageNameEnglish}`,
                speak: isChinese ? speakingName : speakingNameEnglish,
                read: isChinese ? readingName : readingNameEnglish,
                write: isChinese ? writingName : writingNameEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default Language;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/Language.js